export enum MaintenanceScenario {
  Improvements = 'IMPROVEMENTS',
}

export const MaintenanceCopy: Record<MaintenanceScenario, {title: string; body: string}> = {
  [MaintenanceScenario.Improvements]: {
    title: 'Improvements',
    body: `We’re currently making a series of improvements to our dashboards to enhance reliability, performance, and overall visibility.<br>
While these upgrades are in progress, some metrics and figures may appear temporarily delayed or slightly out of sync. Our team is actively working through the updates, and we expect everything to be fully refreshed within the next few hours.<br>
Thank you for your patience while we make your portal experience even better.`,
  },
  
};